<template>
  <div class="min-h-screen w-screen overflow-hidden flex flex-col">
    <div>
      <step-progress step="1" :back-to="backTo" class="py-4 mx-auto bg-dark-blue px-4"></step-progress>
    </div>
    <div
        class="bg-white lg:shadow-lg p-6 lg:py-12 lg:px-16 mx-auto lg:max-w-6xl lg:my-20 flex flex-1 lg:flex-grow-0 flex-wrap justify-center">

      <div class="text-center">
        <p class="hidden lg:block uppercase text-sm font-bold text-medium-blue w-full">Test :
          {{ $page.props.survey.title }}</p>

        <div>
          <!--<h2 class="text-lg lg:text-2xl font-bold mt-2 lg:mt-6" v-if="!$page.props.submission.package" v-html="$trans('app.packages.select-package')"></h2>-->
          <h2 class="text-lg lg:text-2xl font-bold mt-2 lg:mt-6">
            {{ $trans('app.packages.upgrade') }}
          </h2>

          <div class="flex flex-col items-center">
            <h2 class="text-lg lg:text-2xl font-bold mb-4 mt-2 lg:mt-6"
                v-html="$trans('app.packages.agem-reasons')"></h2>
            <bullet-point bullet-color="text-medium-blue" class="mb-2">{{
                $trans('app.packages.reason1')
              }}
            </bullet-point>
            <bullet-point bullet-color="text-medium-blue" class="mb-2">{{
                $trans('app.packages.reason2')
              }}
            </bullet-point>
            <bullet-point bullet-color="text-medium-blue" class="mb-2">{{
                $trans('app.packages.reason3')
              }}
            </bullet-point>
          </div>
        </div>

        <div
            class="flex flex-wrap lg:flex-nowrap items-center lg:justify-between justify-center space-y-2 lg:space-y-0 lg:space-x-4 bg-beige p-5 mt-8 rounded shadow-lg">
          <bullet-point bullet-color="text-medium-blue">{{ $trans('app.packages.pay-difference') }}</bullet-point>
          <bullet-point bullet-color="text-medium-blue">{{ $trans('app.packages.results-247') }}</bullet-point>
        </div>

        <pricing-cards class="mt-8" :border="true" :prices="$page.props.prices" :display="allowedPackages">
          <template #diamond-package>
            <bubble-button @click.prevent="buy('diamond')" :disabled="buttonsDisabled">
              {{ $trans('app.choose-package') }}
            </bubble-button>
          </template>
          <template #gold-package>
            <bubble-button @click.prevent="buy('gold')" :disabled="buttonsDisabled">{{ $trans('app.choose-package') }}
            </bubble-button>
          </template>
          <template #silver-package>
            <bubble-button @click.prevent="buy('silver')" :disabled="buttonsDisabled">
              {{ $trans('app.choose-package') }}
            </bubble-button>
          </template>
          <!--<template #bronze-package>-->
          <!--    <bubble-link :href="route('submission.results', $page.props.submission.id)" :disabled="buttonsDisabled">{{$trans('app.choose-package')}}</bubble-link>-->
          <!--</template>-->
        </pricing-cards>
      </div>
    </div>
  </div>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import StepProgress from '@/Components/StepProgress.vue'
import PricingCards from "@/Components/PricingCards";
import BubbleButton from "@/Components/BubbleButton";
import BubbleLink from "@/Components/BubbleLink";
import BulletPoint from "@/Components/BulletPoint";

export default {
  components: {PricingCards, AppLayout, StepProgress, BubbleButton, BubbleLink, BulletPoint},

  mounted() {
    let stripeScript = document.createElement('script')
    stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
    document.head.appendChild(stripeScript)
  },

  data() {
    return {
      buttonsDisabled: false,
    }
  },

  computed: {
    backTo() {
      return route('survey.start', this.$page.props.survey.slug);
    },
    allowedPackages() {
      return this.$page.props.allowedPackages
    }
  },

  methods: {
    buy(formula) {
      this.buttonsDisabled = true
      // Create an instance of the Stripe object with your publishable API key
      const stripe = Stripe(process.env.MIX_STRIPE_KEY);

      axios.post(route('packages.buy'), {package: formula, survey: this.$page.props.survey.id})
          .then(function (session) {
            return stripe.redirectToCheckout({sessionId: session.data.id});
          })
          .then(function (result) {
            // If redirectToCheckout fails due to a browser or network
            // error, you should display the localized error message to your
            // customer using error.message.
            this.buttonsDisabled = false
            if (result.error) {
              alert(result.error.message);
            }
          })
          .catch(function (error) {
            console.error("Error:", error);
          });
    },
  }
}
</script>

